<app-record-modifications *ngIf="viewMode === 'RECORD_MODIFICATION'"></app-record-modifications>
<app-eod-sign-off *ngIf="viewMode === 'EOD_SIGN_OFF'"></app-eod-sign-off>